<template>
  <el-col :span="24" ref="trxContainer">
    <el-row type="flex" justify="start" align="middle" class="v-padded-s trx-title-container" ref="trxTitleContainer">
      <el-col :span="12" class="h-padded left-aligned-col">
        <el-row type="flex" align="middle" justify="start">
          <h2 style="margin: 0; font-weight: 100;">
            EDIT {{ arStatus }} {{ (form && form.hasOwnProperty('number') && form.number) ? form.number : '' }}
            {{ originalHeader.status === 'AUDITED' ? `(${originalHeader.status})` : '' }}
          </h2>
        </el-row>
      </el-col>
      <DataEntryButtons
        :status="originalHeader.status"
        :isReadOnly="readOnly"
        :isBalanced="transactionIsBalanced"
        :isSaving="isSaving"
        :isSaveable="isSaveable"
        :hasBeenChanged="hasBeenChanged"
        :disableDistChanges="disableDistChanges"
        :disableAuditBtn="!!disableAuditBtn"
        :disablePostBtn="!!disablePostBtn"
        :printingOnly="!!printingOnly"
        :transactionType="transactionType"
        :numberOfFiles="numberOfFiles"
        @addNew="addNew"
        @toggleReadOnly="toggleReadOnly"
        @dropdownClick="handleDropdownClick"
        @goBack="goBack"
        @auditBtnClick="handleAuditBtnClick('Accounts Receivable')"
        @postBtnClick="handlePostBtnClick('Accounts Receivable')"
        @otherActions="otherActions"
        @submit="handleSubmit"
      />
    </el-row>
    <el-row type="flex" ref="mockTrxTitleContainer" />
    <el-row justify="start" align="top" type="flex" class="trx-header" ref="trxHeaderContainer">
      <el-col :span="8" class="left-aligned-col">
        <el-row justify="start" align="top" type="flex">
          <HeaderFields
            title="Customer"
            :openCreateModal="openCreateModal"
            :fields="fields.customer"
            :form="form"
            :idPrefix="'a-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Batch"
            :fields="fields.batch"
            :form="form"
            :idPrefix="'b-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="padding: 0 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Bid Details"
            :fields="fields.bidDetails"
            :form="form"
            :idPrefix="'c-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formatDateFields="formatDateFields"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="padding-left: 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Customer Info"
            :fields="fields.transactionInfo"
            :form="form"
            :lines="lines"
            :idPrefix="'e-'"
            :modalOpen="dialogVisible"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
    </el-row>
    <el-row v-if="lines" justify="start" align="middle" type="flex" id="trx-lines-container">
      <DistributionLines
        v-if="dataLoaded"
        entityType="ar"
        ref="distribution-lines"
        :fields="lineFields"
        :readOnly="readOnly || isSaving"
        :existingLines="originalLines"
        :modalOpen="dialogVisible"
        :parentForm="form"
        :initLines="20"
        :clearFields="lineFieldsToClear"
        @linesHaveBeenChanged="setLinesHaveBeenChanged"
        @formatMoneyFields="formatLineMoneyField"
        @updateLines="updateLines"
      />
      <LinesLoading v-else :distLinesHeight="distLinesHeight" />
    </el-row>
    <el-dialog
      title="Confirm cancellation"
      v-model="dialogVisible"
      width="30%"
      :show-close="false"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <span>
        Do you wish to save your changes?
      </span>
      <template v-slot:footer><span class="dialog-footer">
        <el-button class="exit-modal-btn" @click="cancelExit">
          Cancel
        </el-button>
        <el-button class="exit-modal-btn" type="primary" @click="goBack(true)">
          No
        </el-button>
        <el-button class="exit-modal-btn" type="primary" @click="handleSubmit(false)">
          Yes
        </el-button>
      </span></template>
    </el-dialog>
    <el-dialog
      id="docs-dialog"
      title="View/Upload Documents"
      width="45%"
      top="10%"
      v-model="dropzoneVisible"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <document-dialog
        :transaction="form"
        :dz-options="setupDropzoneOptions()"
        @upload-success="dzSuccess"
        @upload-error="dzFailure"
        @upload-remove="dzRemove"
      />
    </el-dialog>
    <NewBatch @populateFieldWithNewModel="populateFieldWithNewModel" />
    <CustomerVendorForm :type="customerVendorFormType" :modelId="modelId" @updateModelIdProp="updateVendorModelId" @populateFieldWithNewModel="populateFieldWithNewModel" />
  </el-col>
</template>

<script>
  /* eslint-disable camelcase */
  /* eslint-disable no-return-assign */
  import { mapGetters } from 'vuex'
  import DistributionLines from '@/components/DistributionLinesNew.vue'
  import HeaderFields from '@/components/HeaderFields.vue'
  import NewBatch from '@/components/RouteComponents/Batches/NewBatch.vue'
  import CustomerVendorForm from '@/components/FormComponents/CustomerVendorForm.vue'
  import DataEntryButtons from '@/components/DataEntryButtons.vue'
  import sortLines from '@/utils/helpers/DataEntryViews/SortLines'
  import { trackHeaderChanges, trackDistributionChanges } from '@/utils/helpers/DataEntryViews/TrackChanges'
  import { isTransactionBalanced } from '@/utils/helpers/DataEntryViews/IsTransactionBalanced'
  import { transactionMixins } from '@/Mixins/Transactions'
  import { transactionEditViewMixins } from '@/Mixins/TransactionEditViews'
  import { arMixins } from '@/Mixins/ArMixins'
  import DocumentDialog from '@/components/DocumentDialog.vue'
  import LinesLoading from '@/components/LinesLoading.vue'
  import store from '@/store/store'

  export default {
    components: {
      DistributionLines,
      HeaderFields,
      NewBatch,
      CustomerVendorForm,
      DataEntryButtons,
      DocumentDialog,
      LinesLoading
    },
    mixins: [ transactionMixins, transactionEditViewMixins, arMixins ],
    data () {
      const { getArById, getArLinesByTransactionId, getBatchById, getCustomerById } = this.$store.getters
      const c = getArById(this.$route.params.id)
      let lines = Object.values(getArLinesByTransactionId(c.id)).map((line, i) => {
        return { line_number: line.line_number || i + 1, form: { ...this.setMarkupAmount(line) } }
      })
      return {
        modelId: null,
        transactionType: { name: 'ar', path: '/ars/', prettyName: 'Accounts Receivable' },
        originalHeader: c,
        originalLines: lines,
        form: {
          customer: { label: getCustomerById(c.customer)?.name || '', value: c.customer || '' },
          batch: { label: getBatchById(c.batch)?.name || '', value: c.batch || '' },
          number: c.number || '',
          date: c.date || '',
          description: c.description || '',
          period: c.period || '',
          date_due: c.date_due || '',
          amount_decimal: c.amount_decimal || '',
          status: c.status,
          effective_date: c.effective_date || ''
          // markup_type: c.markup_type || '',
          // markup_amount_decimal: c.markup_amount_decimal || '',
          // markup_rate: c.markup_rate || ''
        },
        lines,
        dialogVisible: false,
        readOnly: !['DRAFT', 'OPEN', 'AUDITED'].includes(c.status),   // TODO: ask about what statuses render AR readonly
        createModals: { batch: { visible: false } },  // TODO: still needed?
        changesWereSaved: false,
        transactionIsBalanced: false,
        amountHasChanged: false,
        statusToRestore: '',
        altRoute: null,
        currentCustomerSelection: '',
        lineFieldsToClear: [],
        ready: false,
        disableAuditBtn: null,
        disablePostBtn: null,
        printingOnly: null,
        onSubmitOpts: {},
        notificationBox: undefined,
        dropzoneVisible: false
      }
    },
    methods: {
      /**
       * Updates modelId prop passed to customer create/edit modal
       */
      updateVendorModelId (id) {
        this.modelId = id
      },
      /**
       * Handles navigation when the "Back" button is hit
       */
      goBack (reset = false) {
        if (reset) this.hasBeenChanged = false
        this.ready = false
        if (this.altRoute) {
          this.$router.push(this.altRoute)
        } else {
          this.$router.push({ name: 'ARs' })
        }
      },
      /**
       * Submits the form.
       * @param saveOnly Enables or disables any navigation that should occur after the transaction is saved
       * @param explicitDeltas Specifies hard-coded deltas that need to be set, such as status
       * @param reportToRun Specifies type of report to run once saved. Can be 'audit' or 'posting'
       */
      handleSubmit (saveOnly, explicitDeltas = null, reportToRun = null) {
        if (this.$refs['distribution-lines'].errors.length) {
          this.$notify({ title: 'Error saving distribution changes', message: 'Incomplete lines', type: 'error' })
          return
        }
        if (this.dialogVisible) this.handleDialogVisible(false)   // Close any open dialog boxes
        let removedLines = this.removeDeletedLines()
        const { headerDeltas, lineDeltas } = this
        if (explicitDeltas) this.headerDeltas = Object.assign(headerDeltas, explicitDeltas)
        const hDeltaCount = Object.keys(headerDeltas).length
        const lDeltaCount = Object.keys(lineDeltas).length
        if (hDeltaCount && !lDeltaCount) {
          this.isSaving = true
          this.saveHeaderChangesOnly('Ar', saveOnly, reportToRun)
        } else if (!hDeltaCount && lDeltaCount) {
          this.saveLineChangesOnly('Ar', saveOnly, reportToRun)
        } else if (hDeltaCount && lDeltaCount) {
          this.saveHeaderAndLineChanges('Ar', saveOnly, reportToRun)
        } else {
          isTransactionBalanced(this)
          this.checkForChanges()
          if (removedLines.length) {
            removedLines.forEach(lineNum => this.$refs['distribution-lines'].removeLine(lineNum))
          }
        }
      },
      /**
       * Updates header form
       * @param form
       */
      updateForm (form) {
        this.form = Object.assign({}, form)
        isTransactionBalanced(this)
        this.headerDeltas = trackHeaderChanges(this.form, this.originalHeader)
        this.checkForChanges()
        if (this.form.customer.value) this.currentCustomerSelection = this.form.customer.value
      },
      /**
       * Updates distribution lines
       * @param lines
       */
      updateLines (lines) {
        this.lines = lines
        this.linesChanged()
      },
      /**
       * Checks whether any changes were made to the distribution lines
       */
      linesChanged () {
        this.lineDeltas = trackDistributionChanges(this.lines, this.originalLines)
        isTransactionBalanced(this)
        this.checkForChanges()
      },
      /**
       * Checks whether AR.balance < AR.amount_with_markups. If so, warns the user that there has been a payment
       * applied, and a refund (may) be necessary.
       */
      async handleVoidingAr () {
        const { amount_with_markups_decimal, balance_decimal } = this.originalHeader
        if (parseFloat(balance_decimal) < parseFloat(amount_with_markups_decimal)) {
          try {
            await this.$confirm('A payment has been applied, and refund may be necessary. Click "Continue" to void this transaction.', 'Warning', {
              confirmButtonText: 'Continue',
              cancelButtonText: 'Cancel',
              type: 'warning'
            })
            this.handleSubmit(true, { status: 'VOIDED' })
            return true
          } catch (e) {
            this.$message({ type: 'info', message: 'Voiding canceled' })
            return true
          }
        } else {
          return false
        }
      },
      /**
       * Open new batch or new customer modal
       * @param type
       */
      openCreateModal (type) {
        if (type === 'customer') {
          this.$store.dispatch('changeModalVisibility', { entityType: 'customerVendorForm', visible: true, inDataEntryView: true, type: 'customer' })
        } else {
          this.createModals[type].visible = true
        }
      },
      /**
       * Close new batch or new customer modal
       * @param type
       */
      closeCreateModal (type) {
        this.createModals[type].visible = false
      },
      /**
       * Updates the status field in the header whenever the latest data for this AR hits the store,
       * then calls this.disableHeaderFields if the AR is closed, posted, or voided.
       */
      updateHeaderStatusField () {
        let tmp = Object.assign({}, this.form)
        tmp.status = this.originalHeader.status
        this.form = Object.assign({}, tmp)
      },
      /**
       * Disables specific header fields
       */
      disableHeaderFields () {
        let tmpFields = Object.assign({}, this.fields)
        tmpFields.customer.inputFields.map(v => {
          if (v.name === 'customer') {
            v.disabled = true
            v.addBtn = false
          }
          return v
        })
        tmpFields.batch.inputFields.map(v => {
          if (v.name === 'batch') {
            v.disabled = true
            v.addBtn = false
          }
        })
        tmpFields.bidDetails.inputFields.map(v => {
          if (v.name === 'amount_decimal') v.disabled = true
          if (v.name === 'discount_decimal') v.disabled = true
          return v
        })
        this.fields = Object.assign({}, tmpFields)
      },
      /**
       * Sets the markup_amount field based on the value of markup_type and markup_amount_decimal or markup_rate.
       * This is done because we're using one common field for the amount for which an AR line should be marked up.
       * The value of this new markup_amount field represents either a percentage or a fixed amount based on the value
       * of markup_type. When an AR line is PATCHED or POSTED, a markup_rate or markup_amount_decimal field is created
       * (depending on the value of markup_type) and its value is set to the value of markup_amount.
       * @param lineForm
       */
      setMarkupAmount (lineForm) {
        let form = Object.assign({}, lineForm)
        form.markup_amount = ''
        if (form.markup_type === 'AMT' && form.markup_amount_decimal) {
          form.markup_amount = form.markup_amount_decimal
          delete form.markup_amount_decimal
        } else if (form.markup_type === 'PCT' && form.markup_rate) {
          form.markup_amount = form.markup_rate
          delete form.markup_rate
        }
        delete form.markup_amount_decimal
        delete form.markup_rate
        return Object.assign({}, form)
      }
    },
    computed: {
      ...mapGetters({
        getArs: 'getArs',
        getArById: 'getArById',
        getArLineById: 'getArLineById',
        getLineById: 'getLineById',
        getArLinesByTransactionId: 'getArLinesByTransactionId',
        getArLines: 'getArLines',
        getPeriodById: 'getPeriodById'
      }),
      /**
       * Returns a string that corresponds to the proper verbiage for an AR transaction that is in a specific status
       * state. For instance, an AR that has a status of 'OPEN' is a bid, while a posted AR is a bill.
       */
      arStatus () {
        if (this.originalHeader && this.originalHeader.status) {
          switch (this.originalHeader.status) {
            case 'DRAFT':
              return 'DRAFT BID'
            case 'OPEN':
            case 'AUDITED':
              return 'BID'
            case 'POSTED':
              return 'BILL'
            case 'VOIDED':
            case 'CLOSED':
              return this.originalHeader.status + ' BILL'
            default:
              return this.originalHeader.status
          }
        }
      },
      selectedPeriod () {
        const ar = this.getArById(this.$route.params.id)
        if (ar && ar.period && this.getPeriodById(ar.period).id) {
          return this.getPeriodById(ar.period)
        }
      },
      fields () {
        const c = this.getArById(this.$route.params.id)
        let fields = {
          customer: {
            inputFields: [
              {
                name: 'customer',
                label: 'Customer',
                dataType: 'string',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'customers' },
                required: true,
                triggerOnFocus: false,
                msg: 'Please select a customer',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status),
                addBtn: !['POSTED', 'CLOSED', 'VOIDED'].includes(c.status)
              }
            ],
            displayFields: [
              {
                name: 'customer',
                label: 'Type',
                value: this.form.customer.value ? this.getCustomerById(this.form.customer.value).entity_type : ''
              },
              {
                name: 'customer',
                label: 'Work State',
                value: this.customerWorkState
              }
            ]
          },
          batch: {
            inputFields: [
              {
                name: 'batch',
                label: 'Batch Name',
                dataType: 'number',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'batches', params: { active: true } },
                required: true,
                triggerOnFocus: false,
                msg: 'Please select a batch',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status),
                addBtn: !['POSTED', 'CLOSED', 'VOIDED'].includes(c.status)
              }
            ],
            displayFields: [
              {
                name: 'batch',
                label: 'Company',
                value: this.batchAttributes.company ? this.batchAttributes.company.name : ''
              },
              {
                name: 'batch',
                label: 'Production',
                value: this.batchAttributes.production ? this.batchAttributes.production.name : ''
              },
              {
                name: 'batch',
                label: 'Bank',
                value: this.batchAttributes.bank ? this.batchAttributes.bank.name : ''
              },
              {
                name: 'batch',
                label: 'Currency',
                value: this.batchAttributes.currency ? this.batchAttributes.currency.code : ''
              }
            ]
          },
          bidDetails: {
            inputFields: [
              {
                name: 'number',
                label: 'Number',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status)
              },
              {
                name: 'date',
                label: 'Date',
                dataType: 'string',
                fieldType: 'date',
                required: true,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status),
                msg: 'Please specify a date'
              },
              {
                name: 'date_due',
                label: 'Due Date',
                dataType: 'string',
                fieldType: 'date',
                disabled: ['CLOSED', 'VOIDED'].includes(c.status),
                msg: 'Please specify a due date'
              },
              {
                name: 'effective_date',
                label: 'Effective Date',
                dataType: 'string',
                required: this.effectiveDateMandatory,
                fieldType: 'date'
              },
              {
                name: 'description',
                label: 'Description',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status),
                msg: 'Please provide a description',
                min: 3
              },
              {
                name: 'period',
                label: 'Period',
                dataType: 'number',
                fieldType: 'select',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status),
                options: [
                  { label: 'Next', value: '', selected: !(this.currentPeriod && this.currentPeriod.id) }
                ]
              },
              {
                name: 'amount_decimal',
                label: 'Amount',
                dataType: 'string',
                fieldType: 'money',
                required: true,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status),
                isMoney: true
              }
            ]
          },
          transactionInfo: {
            existingModelFields: [
              {
                label: 'Amt w/ Markup',
                value: this.amountWithMarkups
              },
              {
                label: 'Balance',
                value: c.balance_decimal || ''
              },
              {
                label: 'Amount Paid',
                value: c.amount_paid_decimal || ''
              }
            ]
          }
        }
        if (this.currentPeriod && this.currentPeriod.id) {
          fields.bidDetails.inputFields[5].options.push({ label: 'Current', value: this.currentPeriod.id })
        }
        if (this.selectedPeriod && this.currentPeriod && this.currentPeriod.id !== this.selectedPeriod.id) {
          fields.bidDetails.inputFields[5].options.push({
            label: `Ending ${this.selectedPeriod.end}`,
            value: this.selectedPeriod.id,
            selected: true
          })
        }
        return fields
      }
    },
    watch: {
      /**
       * Watches the AR store for any new data returned by the API. When this transaction is updated,
       * the API will return a fresh copy, which will hit the store and trigger the following updates
       * to this component.
       */
      getArs () {
        const newHeader = this.getArById(this.originalHeader.id)
        if (newHeader && Object.keys(newHeader).length) {
          this.originalHeader = Object.assign({}, newHeader)
          this.updateHeaderStatusField()
          this.readOnly = !['DRAFT', 'OPEN', 'AUDITED'].includes(this.originalHeader.status)
        }
      },
      /**
       * Watches the AR store's lines property for any new or updated distribution lines.
       * This is needed in order to render offset lines created by the API on the fly.
       */
      getArLines () {
        const recent = () => {
          let incoming = Object.values(this.getArLinesByTransactionId(this.$route.params.id))
          return incoming.map((line, i) => {
            const line_number = line.line_number || i + 1
            return { line_number, form: Object.assign({}, line) }
          })
        }
        if (this.ready && (JSON.stringify(recent()) !== JSON.stringify(this.originalLines))) { // this.ready prevents this logic from running when component is created
          this.originalLines = recent()
          this.lines = recent()
          if (this.$refs && this.$refs['distribution-lines']) {
            this.$refs['distribution-lines'].rebuildLines()
          }
        }
        this.ready = true
      },
      /**
       * Determines whether the transaction's amount has changed
       */
      headerDeltas () {
        this.amountHasChanged = Object.keys(this.headerDeltas).includes('amount_decimal')
      }
    },
    /**
     * Things that should be done when the component is created
     */
    created () {
      this.lines = sortLines(this.lines)
      isTransactionBalanced(this)
      this.updateForm(this.form)
    },
    /**
     * Things that should be done before the route resolves and the component is created
     * @param to
     * @param from
     * @param next
     * @return {Promise<void>}
     */
    async beforeRouteEnter (to, from, next) {
      const { getCurrentPeriod } = store.getters
      const periodExists = getCurrentPeriod && Object.keys(getCurrentPeriod).length
      try {
        const resp = await store.dispatch('fetchArsWithQuery', { query: { id: to.params.id }, storeLines: true })
        let promises = [
          store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' }),
          store.dispatch('fetchUiSetting', { name: 'CONFIRM_ON_POST' })
        ]
        if (resp && resp.entities) {
          const deps = await store.dispatch('findDependencies', resp.entities) || []
          promises = [...promises, ...deps]
        }
        await Promise.all(promises)
        if (!periodExists) {
          await store.dispatch('fetchPeriodsWithQuery', { active: 'True' })
        }
        next()
      } catch (e) {
        console.log(e)
        // TODO: notify user
      }
    }
  }
</script>

<style scoped>
  .h-padded {
    padding: 0 12px;
  }
  .v-padded-s {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  .el-form-item__label {
    padding: 20px !important;
    border: 1px solid pink;
  }
</style>
